import script from "./ProviderDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ProviderDetails.vue?vue&type=style&index=0&id=b7dcb03a&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7dcb03a"]])

export default __exports__